import React from "react";
import {
  createServiceCode,
  updateServiceCode,
  getServiceCodeDetail,
} from "../../helpers/backend_helper";
import CodeDetail from "./CodeDetail";

const ServiceDetail = (props) => (
  <CodeDetail
    {...props}
    codeLabel="Service Code"
    getCodeDetail={getServiceCodeDetail}
    createCode={createServiceCode}
    updateCode={updateServiceCode}
  />
);

export default ServiceDetail;
